import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: inline-flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    ", "\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { marginAttributes } from '../../../system/attributes';
import { getPropsBlocker } from '../../../utils';
var propertyList = {};

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var theme = _ref.theme;
  return theme.componentOverrides.TableCellLabel.Root.base;
};

export var TableCellLabelRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject(), getRootDynamicStyle, marginAttributes);